// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
    <sub-header header="\$ctrl.loanProduct.productDefinition.productName || 'Create new'"></sub-header>

  <div class="tab-menu">
    <ul class="nav-tabs">
      <li class="active">
        <a data-target="#tab-general" data-toggle="tab">
          <span><i ng-show="\$ctrl.generalForm.\$invalid" class="icon icon-warning-sign"></i>General</span>
        </a>
      </li>
      <li>
        <a data-target="#tab-interests" data-toggle="tab">
        <span><i ng-show="\$ctrl.interestsForm.\$invalid"
                 class="icon icon-warning-sign"></i>Amortization</span>
        </a>
      </li>
      <li ng-if="\$ctrl.loanProduct.useInterestRateBoard">
        <a data-target="#tab-interest-rate-board" data-toggle="tab">
        <span><i ng-show="\$ctrl.interestsRateBoardForm.\$invalid"
                 class="icon icon-warning-sign"></i>Interest rate board</span>
        </a>
      </li>
      <li ng-if="\$ctrl.loanProduct.honorHolidays">
        <a data-target="#tab-holidays" data-toggle="tab">
          <span><i ng-show="\$ctrl.holidayForm.\$invalid || !\$ctrl.holidayFormsValid()"
                   class="icon icon-warning-sign"></i>Holidays</span>
        </a>
      </li>
      <li>
        <a data-target="#tab-charges" data-toggle="tab">
          <span><i ng-show="\$ctrl.chargesForm.\$invalid" class="icon icon-warning-sign"></i>Charges & Fees</span>
        </a>
      </li>
      <li>
        <a data-target="#tab-advanced" data-toggle="tab">
          <span><i ng-show="\$ctrl.advancedForm.\$invalid" class="icon icon-warning-sign"></i>Advanced</span>
        </a>
      </li>
      <li>
        <a data-target="#tab-letters" data-toggle="tab">
          <span><i ng-show="\$ctrl.lettersForm.\$invalid || !\$ctrl.letterFormsValid()" class="icon icon-warning-sign"></i>Letters</span>
        </a>
      </li>
      <li ng-if="\$ctrl.loanProduct.id">
        <a data-target="#tab-mappings" data-toggle="tab">
          GL Mappings
        </a>
      </li>
      <li class="disabled" ng-if="!\$ctrl.loanProduct.id">
        <a>
          GL Mappings
        </a>
      </li>
    </ul>
  </div>

  <div class="tab-content" ng-form="\$ctrl.parentForm">

    <div class="tab-pane active" id="tab-general">
      <loan-product-general-form form="\$ctrl.generalForm"
                                 loan-product="\$ctrl.loanProduct"
                                 branches="\$ctrl.branches"></loan-product-general-form>
    </div>
    <div class="tab-pane" id="tab-interests">
      <loan-product-amortization-form form="\$ctrl.interestsForm"
                                      loan-product="\$ctrl.loanProduct"></loan-product-amortization-form>
    </div>
    <div class="tab-pane" id="tab-interest-rate-board" ng-if="\$ctrl.loanProduct.useInterestRateBoard">
      <loan-interest-rate-board form="\$ctrl.interestRateBoardForm"
                                board="\$ctrl.loanProduct.interestRateBoard"
                                min-interest-rate="\$ctrl.loanProduct.minInterestRate"
                                max-interest-rate="\$ctrl.loanProduct.maxInterestRate"
                                default-interest-rate="\$ctrl.loanProduct.defaultInterestRate">
      </loan-interest-rate-board>
    </div>
    <div class="tab-pane" id="tab-holidays">
      <loan-product-holidays form="\$ctrl.holidayForm" loan-product="\$ctrl.loanProduct"></loan-product-holidays>
    </div>
    <div class="tab-pane" id="tab-charges">
      <loan-product-charges-form form="\$ctrl.chargesForm"
                                 ng-if="\$ctrl.loanProduct"
                                 loan-product="\$ctrl.loanProduct">
      </loan-product-charges-form>
    </div>
    <div class="tab-pane" id="tab-advanced">
      <loan-product-advanced-form form="\$ctrl.advancedForm"
                                  loan-product="\$ctrl.loanProduct"></loan-product-advanced-form>
    </div>
    <div class="tab-pane" id="tab-letters">
      <loan-product-letter form="\$ctrl.lettersForm"
                           loan-product="\$ctrl.loanProduct">
      </loan-product-letter>
    </div>
    <div class="tab-pane" id="tab-mappings" ng-if="\$ctrl.loanProduct.id">
      <gl-mappings
        product-type="\$ctrl.loanProduct.productDefinition"
        custom-fees="\$ctrl.loanProduct.feeDefinitions"
        hidden-tag-types="\$ctrl.glMappingsHiddenTagTypes()"
        instance-ready="\$ctrl.setGlMappingComponent(instance)">
      </gl-mappings>
    </div>

    <div class="clearfix"></div>

    <div class="buttons" ng-if="!\$ctrl.chargesForm.wizardMode">
      <button class="btn btn-warning" ng-click="\$ctrl.cancel()">Cancel</button>
      <button class="btn btn-primary"
              ng-disabled="\$ctrl.parentForm.\$invalid
                          || !\$ctrl.holidayFormsValid()
                          || !\$ctrl.letterFormsValid()"
              ng-click="\$ctrl.confirmChanges()">Save
      </button>
    </div>

    <div class="clearfix"></div>
  </div>
</section>

`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/loan/details/loan-product-details.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;